import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { ROUTE } from '~/app/routes';

export const PageDocumentsRedirect: FC = () => <Navigate to={ROUTE.STATEMENTS} replace />;
